// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1MIei","balanceDisclaimer":"posDashboard_balanceDisclaimer__1SS7r"};